module.exports = __webpack_public_path__ + "img/Analytic Reports-1.041ab06c.svg";